import { gql } from '@apollo/client';
import { sendEvent } from 'services/analytics';

import {
  AUTH_USER,
  AUTH_IN_PROGRESS,
  SIGNUP_BY_EMAIL_IN_PROGRESS,
  SIGNUP_BY_EMAIL,
  SIGNUP_ERROR,
  FORGOT_IN_PROGRESS,
  FORGOT_SUCCESS,
  AUTH_CLEARDOWN,
} from '../../constants';
import Auth from './Auth';
import { authError } from './error';

const MUTATION = {
  SEND_PASSWORD_EMAIL: gql`
    mutation SendPasswordEmail($email: String) {
      SendPasswordEmail(email: $email)
    }
  `,
};

export function signupError(error, code) {
  const timestamp = Date.now();
  return {
    type: SIGNUP_ERROR,
    error,
    code,
    timestamp,
  };
}

export function signupUserByEmail({ email, password, metadata, authParams, returnTo }) {
  return async dispatch => {
    dispatch({ type: SIGNUP_BY_EMAIL_IN_PROGRESS });

    try {
      const auth = new Auth(authParams);
      sendEvent({
        event: 'formSubmission',
        formType: 'signup',
        formPosition: 'modal',
      });
      await auth.signupByEmail(email, password, metadata, returnTo);
      dispatch({ type: SIGNUP_BY_EMAIL });
    } catch (error) {
      const errorMsg = error.description || error.message || 'Unspecified error';
      dispatch(signupError(errorMsg, error.code || error.name));
      throw error;
    }
  };
}

export function socialSignin({ provider, authParams, returnTo }) {
  return async dispatch => {
    dispatch({ type: AUTH_IN_PROGRESS });

    try {
      const auth = new Auth(authParams);
      sendEvent({
        event: 'formSubmission',
        formType: 'socialSignin',
        formPosition: 'modal',
        method: provider,
      });
      sendEvent({
        event: 'Auth.Login',
        method: provider,
      });
      await auth.socialSignin(provider, returnTo);
      dispatch({ type: AUTH_USER });
    } catch (error) {
      const errorMsg = error.description || error.message || 'Unspecified error';
      dispatch(authError(errorMsg));
      sendEvent({
        event: 'Auth.LoginFailed',
        method: provider,
        error,
      });
    }
  };
}

export function signinUser({ email, password, authParams, returnTo }, callback) {
  return async dispatch => {
    dispatch({ type: AUTH_IN_PROGRESS });
    try {
      const auth = new Auth(authParams);
      sendEvent({
        event: 'formSubmission',
        formType: 'signin',
        formPosition: 'modal',
      });
      await auth.signin(email, password, returnTo);
      sendEvent({
        event: 'Auth.LoginComplete',
        method: 'email',
      });
      dispatch({ type: AUTH_USER });
      return callback();
    } catch (error) {
      const errorMsg = error.description || error.message || 'Unspecified error';
      dispatch(authError(errorMsg));
      sendEvent({
        event: 'Auth.LoginFailed',
        method: 'email',
        error,
      });
      return callback(errorMsg);
    }
  };
}

export function changePassword({ email }, callback) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: FORGOT_IN_PROGRESS });
    try {
      const { data, errors } = await client.mutate({
        mutation: MUTATION.SEND_PASSWORD_EMAIL,
        variables: { email },
        errorPolicy: 'all',
      });
      if (errors && errors.length) {
        dispatch(authError(errors[0].message));
        return callback(errors[0].message);
      }
      dispatch({
        type: FORGOT_SUCCESS,
        message: data.SendPasswordEmail,
      });
      return callback();
    } catch (error) {
      const errorMsg = error.description || error.message || 'Unspecified error';
      dispatch(authError(errorMsg));
      sendEvent({
        event: 'Auth.PasswordResetFailed',
        error,
      });
      return callback(errorMsg);
    }
  };
}

export function cleardown() {
  return dispatch => {
    dispatch({ type: AUTH_CLEARDOWN });
  };
}
